<template>
  <div class="slider-back">
    <!--环图片-->
    <div class="img-box">
      <div class="prop-up"></div>
      <img src="@/assets/img/circle.png" class="circle" alt="">
    </div>
    <div>
      <!--题目-->
      <div class="subject">
        <div>{{ $t('natureQue2') }}</div>
      </div>
      <!--选项-->
      <div style="width:115px;margin:calc(0.073 * var(--body-height)) auto 0;">
        <el-radio-group v-model="natureAnswer">
          <el-radio :label="item.answer" :key="index" v-for="(item, index) in answerOpt"></el-radio>
        </el-radio-group>
      </div>
      <!--题目跳转-->
      <div class="subject-jump">
        <span @click="prevClick" class="prev-btn"><i class="icon-left"></i> {{ $t('preQues') }}</span>
        <el-button @click="nextClick" :disabled="countNumber != 0" style="width:160px;" type="primary">{{ $t('nextQues')
          }} <i class="icon-right"></i> ({{ countNumber }}s)
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "nature2",
  data() {
    return {
      //自然题答案
      natureAnswer: '',
      //选项
      answerOpt: [
        { val: 1, answer: this.$t('yes') },
        { val: 2, answer: this.$t('no') },
        { val: 3, answer: this.$t('notSure') }
      ],
      timer: null,
      countNumber: 0,
      positionArr: [
        [this.$t('yes'), '是'],
        [this.$t('no'), '否'],
        [this.$t('notSure'), '不确定']
      ]
    }
  },
  computed: {
    ...mapGetters([
      'natureAnswerArr',
      'codeItem'
    ]),
  },
  mounted() {
    //计时器
    this.countdown()
    this.$store.commit('SET_ANSWER_PERCENT', 15 * 100 / 22)
    this.natureAnswer = this.natureAnswerArr[2][1]
  },
  methods: {

    /**
     * 上一题
     */
    prevClick() {
      if (this.natureAnswerArr[0][1] === this.$t('none')) {
        this.$router.push('/nature1')
      } else {
        this.$router.push('/nature1_1')
      }

    },

    /**
     * 下一题
     */
    nextClick() {
      if (this.natureAnswer === '') {
        this.$toast(this.$t('selectOne'));
        return;
      }
      //保存答案
      this.natureAnswerArr[2][1] = this.natureAnswer
      let codeField = this.positionArr.find(item => item[0] == this.natureAnswer)[1]
      this.codeItem[3][1] = codeField
      // 页面跳转
      if (this.natureAnswer === this.$t('yes')) {
        this.$router.push('/nature2_1')
      } else {
        this.$router.push('/nature3')
      }
    },

    /**
     * 验证码倒计时
     */
    countdown() {
      let that = this;
      this.countNumber = 2;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(function () {
        if (that.countNumber === 0) {
          clearInterval(this.timer);
        } else {
          that.countNumber--;
        }
      }, 1000);
    }
  }
}
</script>


<style scoped lang="less"></style>